import React, { useCallback, useMemo } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy } from "react-table";
// import "assets/scss/TableHistorialDesvinculacion.scss"
import { Container, Row, Col, Table, Button } from 'react-bootstrap';
import { ESTADO_PENDIENTE, functionFormatISODate } from "./Solicitud_Certificados";
import { parseEstado } from './Solicitud_Certificados';
import { Data } from '@react-google-maps/api';
import { classNameIconoBasura } from 'constants/Icons-Font-Awesome';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';



const TableSolicitudesCertificados = ({ dataprops, handleDescargarCertificado, handleAnularSolicitud }) => {

  const data = React.useMemo(
    () => [...dataprops], [dataprops]
  )


  function GetComponentBotonAnularSolicitud(informacionAnularSolicitud) {
    if (informacionAnularSolicitud) {
      const { idSolicitud, estadosolicitud } = informacionAnularSolicitud;
      if (estadosolicitud === ESTADO_PENDIENTE) {
        return (
          <i onClick={async () => await handleAnularSolicitud(idSolicitud)} className={`${classNameIconoBasura} download`} 
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Anular Solicitud de Certificado"
            aria-hidden="true">

          </i>
        )
      }

    }
    return (<div />)
  }



  const columns_usando = React.useMemo(
    () => [
      {
        Header: 'Tipo Certificado',
        accessor: 'tip', // accessor is the "key" in the data
      },
      {
        Header: 'Fecha Solicitud',
        accessor: 'fecs',
        Cell: ({ value }) => {
          var algo = value ? functionFormatISODate(value.toString()) : "";
          return algo;
        }
      },
      {
        Header: 'Dirigido',
        accessor: 'dir',
      },
      {
        Header: 'Observaciones',
        accessor: 'obs',

      },
      {
        Header: 'Estado Solicitud',
        accessor: 'est',

      },
      {
        Header: 'Estado Certificado',
        accessor: 'estc',

      },
      {
        Header: 'Anular Solicitud',
        accessor: 'anularSolicitud',
        Cell: ({ value }) => GetComponentBotonAnularSolicitud(value)
      },
      {
        Header: 'Certificado',
        accessor: 'cert',
        Cell: ({ value }) => {
          {
            if (value.referencia && value.estadocertificado) {
              if (value.estadocertificado === "G") {
                return ("Certificado aún no firmado")
              }
              else if (value.estadocertificado === "F")
                if (value.certificadoVigente) {
                  return (
                    <i
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Descargar Certificado Vigente"
                      onClick={() => handleDescargarCertificado(value.referencia)}
                      className="fas fa-download download"
                      aria-hidden="true">
                    </i>

                  )
                }
                
                else {
                  return ("El certificado no se encuentra vigente")
                }


            }
            else if (value.estadoSolicitud === "AT" && value.idTipoCertificado === 30){
              return ("Su certificado físico ha sido atendido")
            }
            else if(value.estadoSolicitud === "NA"){
              return ("")
            }
            else if (value.idcertificado === undefined){
              return ("Su certificado se encuentra en elaboración")
            }
            
            // else if (value.estadocertificado !== "F") {
            //   return ("Certificado aún no firmado")

            // }
            else{
              return ""
            }

          }
        }
      },


    ],
    [data]
  )


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,

  } = useTable(
    {
      columns: columns_usando,
      data
    },
    useGlobalFilter,
    useSortBy,
    usePagination

  )


  function HandleStyle(header) {
    var s_border = 'solid 1px black'
    var s_background = '#243165'
    var s_color = "white"
    var s_textAlign = "center"
    var s_wordBreak = "break-word"
    var s_width = "auto"

    switch (header) {
      case "#":
        s_width = "50px";
        break;
      case "Observaciones":
        s_width = "250px";
        break;
      case "Estado Solicitud":
        s_width = "100px";
        break;
      case "Estado Certificado":
        s_width = "100px";
        break;
      default:
        break;
    }

    return ({
      border: s_border,
      background: s_background,
      color: s_color,
      textAlign: s_textAlign,
      wordBreak: s_wordBreak,
      width: s_width,
      cursor: "pointer"
    })
  }




  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <React.Fragment>

      <div className='parentTableHistorial'>



        <Row>
          <Col xl={12}>
            <GlobalFilterTable
              filter={globalFilter}
              setFilter={setGlobalFilter}

            />
          </Col>
        </Row>







        <Row>
          <Col xl={12} md={12} sm={12}>
            <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className='mt-3 tableSolicitudesEnviadas'>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        style={HandleStyle(column.Header)}
                      >
                        {column.render('Header')}
                        <span>
                          {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                        </span>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map(row => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => {
                        return (
                          <td
                            className='tableHistorialcolumns'
                            {...cell.getCellProps()}
                            style={{
                              border: 'solid 1px black',

                            }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={typeof (cell.value) === "string" ? cell.value : ""}

                          >
                            {cell.render('Cell')}
                          </td>
                        )
                      })}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
            <div className="containerPaginacionHistorial text-right">
              <span>
                Página{' '}
                <strong>
                  {pageIndex + 1} de {pageOptions.length}
                </strong>{' '}
              </span>
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
              >
                {[5, 10, 15, 25, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize} >
                    Mostrar {pageSize}
                  </option>
                ))}
              </select>
              <button className={canPreviousPage ? "btnAnteriorPaginacion" : "btndisabled"} onClick={() => previousPage()} disabled={!canPreviousPage}>Anterior</button>
              <button className={canNextPage ? "btnSiguientePaginacion" : "btndisabled"} onClick={() => nextPage()} disabled={!canNextPage}   >Siguiente</button>

            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>

  )

}
export default TableSolicitudesCertificados;

